<template>
    <div>
        <NavComponent></NavComponent>
        <SideBarComponent></SideBarComponent>
        <div class="banner" v-bind:style="{backgroundImage:'url(https://cdn.hanlandglobal.com/maintain-banner.jpg)'}">

        </div>
        <div class="content-container">
            <h3>多重保障 为您保驾护航</h3>
            <div class="main">
                <ul>
                    <li>
                        <div class="circle circle1"><img style="width:2.45rem;height:2.25rem;" :src="main_img1"/></div>
                        <h3>品质保障</h3>
                        <p>专注到家服务，经受住客户考验，深耕细作，铸造熟悉到家品质服务形象。</p>
                    </li>
                    <li>
                        <div class="circle circle2"><img style="width:2.2rem;height:2.5rem" :src="main_img2"/></div>
                        <h3>实力保障 </h3>
                        <p>打造专业团队，每名员工均有5年以上服务经验，拥有多项职业技能证书，贴心，完善。技术过硬，是对客户的负责。</p>
                    </li>
                    <li>
                        <div class="circle circle3"><img style="width:2.2rem;height:2.5rem" :src="main_img3"/></div>
                        <h3>承诺保障</h3>
                        <p>一点一滴精细服务，十全十美极致体验。从上报到维修，每一道流程都经过严格培训，确保维修清晰明了，安全高效。</p>
                    </li>
                    <li>
                        <div class="circle circle4"><img style="width:2.15rem;height:2.1rem" :src="main_img4"/></div>
                        <h3>沟通保障</h3>
                        <p>专业的后勤团队负责协助客户与维修员工进行沟通，减少沟通问题，提高工作效率。</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="banner2" v-bind:style="{backgroundImage:'url( https://cdn.hanlandglobal.com/maintain-banner2.jpg)'}">
            <p class="banner-content">汉伦甄选的当地维修人员能够为您提供 <span class="import">专业、及时、高效</span> 的维修,</p>
            <P>确保您的汉伦生活无忧无虑, 真正做到 <span class="import">四大保障</span> 以及 <span class="import">一修到家</span> 的服务流程</P>
        </div>
        <div class="content-container bottom">
            <h3 class="app-title bottom-title">一键到位 服务流程</h3>
            <ul class="main-bottom item-list">
                <li><img :src="icon_img1" style="width:4.1rem;height:4rem;" /><div>系统报修</div></li><img :src="row_img2"/>
                <li><img :src="icon_img2" style="width:3.6rem;height:3.7rem;" />业务安排</li><img :src="row_img2"/>
                <li><img :src="icon_img3" style="width:2.8rem;height:3.85rem;" />上门维修</li><img :src="row_img2"/>
                <li><img :src="icon_img4" style="width:3.7rem;height:3.9rem;" />服务完毕</li><img :src="row_img2"/>
                <li><img :src="icon_img5" style="width:3.85rem;height:4.25rem;" />修后保障</li>
            </ul>
            <img class="line-img" :src="line_img"/>
            <ul class="main-bottom sort">
                <li>01</li><img :src="row_img1"/>
                <li>02</li><img :src="row_img1"/>
                <li>03</li><img :src="row_img1"/>
                <li>04</li><img :src="row_img1"/>
                <li>05</li>
            </ul>
        </div>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'

import main_img1 from '@assets/image/manage/maintain-img1.png'
import main_img2 from '@assets/image/manage/maintain-img2.png'
import main_img3 from '@assets/image/manage/maintain-img3.png'
import main_img4 from '@assets/image/manage/maintain-img4.png'
import icon_img1 from '@assets/image/manage/maintain-icon1.png'
import icon_img2 from '@assets/image/manage/maintain-icon2.png'
import icon_img3 from '@assets/image/manage/maintain-icon3.png'
import icon_img4 from '@assets/image/manage/maintain-icon4.png'
import icon_img5 from '@assets/image/manage/maintain-icon5.png'
import line_img from '@assets/image/manage/line-icon.png'
import row_img1 from '@assets/image/manage/icon-row.png'
import row_img2 from '@assets/image/manage/icon-row2.png'

export default {
    name: 'MaintainPage',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data(){
        return {
            line_img,row_img1,row_img2,
            main_img1,main_img2,main_img3,main_img4,
            icon_img1,icon_img2,icon_img3,icon_img4,icon_img5
        }
    },
    mounted(){

    },
    methods:{

    }

}
</script>
<style lang="scss" scoped>
.banner{
    width: 100%;
    height: 20.8rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 20.8rem;  
}
.banner2{
    width: 100%;
    height: 18rem;
    margin-top:5rem;
    text-align: center;
    color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    p{
        font-size: 1.4rem;
        line-height: 2.8rem;
    }
    .import{
        font-weight: 700;
        font-size: 1.8rem;
    }
}
.banner-content{
    padding-top: 5rem;
}
h3{
    text-align: center;
    color: $color;
    font-size: 1.5rem;
    margin:5rem auto;
}
.main{
    text-align: center;
    ul{
        display: flex;
        justify-content: space-around;
    }
    li{
        width: 14.4rem;
        height: 13.6rem;
        border:1px solid #f9f9f9;
        border-radius: 0.5rem;
        position: relative;
        box-shadow: 0px 5px 9px 1px 
		rgba(147, 147, 147, 0.1);
    }
    .circle{
        width:5.5rem;
        height: 5.5rem;
        border-radius: 50%;
        position: absolute;
        top:-3rem;
        right: 4.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
        div{
            width: 100%;
            height: 100%;
        }
    }
    .circle1{
        background: #6b8fcb;
    }
    .circle2{
        background: #ab8adb;
    }
    .circle3{
        background: #e6b360;
    }
    .circle4{
        background: #50c6c6;
    }
    p{
        color:#3a4a5b;
        padding:0 1.1rem;
        text-align: left;
        font-size: 0.9rem;
    }
    h3{
        margin: 4.5rem 0 1.2rem 0;
    }
}
.bottom-title{
    margin-bottom: 2rem;
}
.bottom{
    padding-bottom: 5rem;
    .line-img{
        width: 100%;
        height: auto;
    }
}
.main-bottom{
    display: flex;
    justify-content:space-around;
    padding:0 1.5rem;
    li{
        font-size: 1.2rem;
        color: $color;
        line-height: 4rem;
        font-weight: 700;
        span{
            display: block;
            width: 5rem;
            height: 5rem;
            margin: 0 auto;
        }
    }
    img{
        width: 0.6rem;
        height: 1rem;
        margin-top:2.6rem;
    }
}
.sort{
        padding:0 2rem;
    li{
        font-size: 1.2rem;;
        letter-spacing: 1px;
        color: #3a4a5b;
    }
    img{
            width: 1.25rem;
            height: 1.3rem;
            margin-top:1.3rem;
        }
}
@media only screen and (max-width: 1024px){
    .banner{
        height: 18.8rem;
        background-size: cover;
    }
    .main{
        padding: 0 3%;
        ul{
            flex-wrap:wrap;
            li{
                margin-bottom: 2rem;
                margin-top: 3rem;
            }
        }
    }
    h3{
        margin: 3rem auto;
    }
    .banner2{
        margin-top: 3rem;
        p{
            width: 80%;
            margin: 0 auto;
        }
        .banner-content{
            padding-top: 2rem;
        }
    }
    .item-list{
        li img{
            display: block;
        }
        img{
            display: none;
        }
    }
    .bottom .line-img{
        width: 94%;
        display: block;
        margin: 0 auto;
    }
}
</style>